// extracted by mini-css-extract-plugin
export default {"tableQuickFilters":"tableQuickFilters--Hdii6 custom-scrollbar"};